import {
  EnvironmentProviders,
  ErrorHandler,
  Provider,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@qaroni-merchant-env/environment';
import * as Sentry from '@sentry/angular';

export const provideSentry = (): (Provider | EnvironmentProviders)[] => {
  return !environment.production
    ? []
    : [
        {
          provide: ErrorHandler,
          useValue: Sentry.createErrorHandler(),
        },
        {
          provide: Sentry.TraceService,
          deps: [Router],
        },
        provideAppInitializer(() => {
          inject(Sentry.TraceService);
        }),
      ];
};
